import { useMemo } from 'react';
import { t } from '@transifex/native';
import { RouteSectionNav } from 'features/common/components/RouteSectionNav';

interface UserGroupTabsProps {
  groupId: string;
  locationSearch?: string;
}

export const UserGroupTabs = ({
  groupId,
  locationSearch = '',
}: UserGroupTabsProps) => {
  const items = useMemo(
    () => [
      {
        id: 'users',
        label: 'Users',
        to: `/admin/user-groups/${groupId}/members/page/1${locationSearch}`,
        // Match `/members`, `/members/page/1`, etc. (initial replace may omit `/page/…`)
        isActive: (pathname: string) =>
          pathname.startsWith(`/admin/user-groups/${groupId}/members`),
      },
      {
        id: 'configuration',
        label: 'Configuration',
        to: `/admin/user-groups/${groupId}/configuration${locationSearch}`,
        isActive: (pathname: string) =>
          pathname.startsWith(
            `/admin/user-groups/${groupId}/configuration`,
          ),
      },
    ],
    [groupId, locationSearch],
  );

  return (
    <RouteSectionNav
      ariaLabel={t('User group section navigation')}
      items={items}
    />
  );
};
